(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-ingredients"] && !Shopify.designMode) return;
  try {
    
  $('.toggle-button-box span.button').click (function(){
        $('.toggle-button-box .button-description').toggleClass('active');
});

  } catch(e) { console.error(e); }
})();
})();
